import { useEffect, useState } from "react";
import { fetchCounts } from "../../Service/UserService";
import DashboardCard from "../../Componants/AdminPannel/DashboardCard";

export default function DashboardHome() {
  const [counts, setCounts] = useState({
    contactCount: 0,
    careerCount: 0,
    jobOpenCount: 0,
    insightsCount: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchCounts();
        setCounts(data);
      } catch (e) {
        console.error(e);
        setError("Failed to load counts");
      } finally {
        setLoading(false);
      }
    };

    load();

    // Live updates: poll every 5s (optional)
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  if (loading) return <p className="text-center mt-6">Loading...</p>;
  if (error)   return <p className="text-center mt-6 text-red-600">{error}</p>;

  return (
    <div className="p-6 bg-white rounded-xl shadow-lg">
      {/* Centered heading & subtitle */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-2">
          Welcome to Admin Panel
        </h2>
        <p className="text-gray-600">
          This is your main dashboard. Use the sidebar to navigate to different sections of the application.
        </p>
      </div>

      {/* Exactly 2 cards per row */}
      <div className="grid grid-cols-2 gap-6 p-6">
        <DashboardCard name="Contacts"      count={counts.contactCount} path="/contact"/>
        <DashboardCard name="Careers"       count={counts.careerCount} path="/get-in-touch"/>
        <DashboardCard name="Job Openings"  count={counts.jobOpenCount} path="/jobs"/>
        <DashboardCard name="Insights"      count={counts.insightsCount} path="/blogs"/>
      </div>
    </div>
  );
}
